/**
 * 数学减法。
 *
 * @category Mathematics
 *
 * @public
 *
 * @param value - 被减数。
 * @param operand - 减数。
 *
 * @returns 差。
 */
export function subtract(value, operand) {
    return value - operand;
}
//# sourceMappingURL=subtract.js.map